/* eslint-disable @typescript-eslint/no-explicit-any */
import { PageTypeSuffix } from '@/constants'
import { useNotification } from '@/containers'
import type { Category } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { useRouter } from 'next/router'
import ImageOptimize from '../ImageOptimize'

interface ChildrenCategoryType {
  data: Category[]
}
export const ChildrenCategory = ({ data }: ChildrenCategoryType) => {
  const router = useRouter()
  const { systemConfig } = useNotification()
  return (
    <div className={`container mb-1 mt-2 flex gap-6 overflow-x-auto pb-1`}>
      {data &&
        data.map((e, i) => {
          return (
            <div
              className='item flex max-w-[120px] flex-[0_0_120px] cursor-pointer flex-wrap justify-center'
              key={i}
              onClick={() =>
                router.push(
                  getTranslate(e?.slugs?.value) + PageTypeSuffix.CATEGORY
                )
              }
            >
              <ImageOptimize
                src={
                  e.image ||
                  systemConfig?.imagePlaceholder ||
                  process.env.NEXT_PUBLIC_IMAGE_PLACEHOLDER ||
                  ''
                }
                alt={getTranslate(e.name)}
                className='h-[60px] w-[60px] rounded-lg object-contain'
              />
              <span className='line-camp-2 mt-1 h-10 w-full overflow-hidden text-ellipsis text-center text-sm font-normal leading-5 text-dark-800'>
                {getTranslate(e.name)}
              </span>
            </div>
          )
        })}
    </div>
  )
}
